import * as _ from 'lodash';
import { BUSINESS_TAX_ID_CONFIG } from '@/data/tax-id-config';
import i18n from '@/plugins/i18n';
import { CoreCorpType, CountryCode } from '@clearbanc/data-common-types';

interface CorpTypeOption {
  key?: number;
  value: string;
  name: () => string;
  nameString: string;
}

export const CORP_TYPE_OTHER: CorpTypeOption = {
  value: 'other_option',
  name: () => i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.other'),
  nameString: i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.other'),
};

interface BusinessTaxIdConfig {
  [countryCode: string]: {
    corpTypes: {
      [corpType: string]: () => string;
    };
  };
}

export type CorporationType =
  | CoreCorpType.Corporation
  | CoreCorpType.LLC
  | (typeof CoreCorpType)['Sole Proprietorship']
  | CoreCorpType.Partnership
  | (typeof CoreCorpType)['Non-profit'];

export type CorpTypeMap = {
  [key in CorporationType]?: () => string;
};

export function corpTypesForCountry(
  countryCode: CountryCode,
): CorpTypeOption[] {
  const defaultCorpTypes: CorpTypeMap = {
    [CoreCorpType.Corporation]: () =>
      i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.corp'),
    [CoreCorpType.LLC]: () =>
      i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.llc'),
    [CoreCorpType['Sole Proprietorship']]: () =>
      i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.sole'),
    [CoreCorpType.Partnership]: () =>
      i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.partnership'),
    [CoreCorpType['Non-profit']]: () =>
      i18n.t('data.taxIdConfig.businessTaxIdConfig.corpTypes.nonprofit'),
  };

  const CORP_TYPES = _.get(
    BUSINESS_TAX_ID_CONFIG as BusinessTaxIdConfig,
    `${countryCode}.corpTypes`,
    defaultCorpTypes,
  ) as Record<string, () => string>;

  const CORP_TYPE_BY_COUNTRY_OPTIONS: CorpTypeOption[] = Object.keys(
    CORP_TYPES,
  ).reduce((acc: CorpTypeOption[], value: string, idx: number) => {
    const name = CORP_TYPES[value];
    return acc.concat({
      key: idx,
      value,
      name,
      nameString: name(),
    });
  }, []);

  // add other option
  CORP_TYPE_BY_COUNTRY_OPTIONS.push({
    key: CORP_TYPE_BY_COUNTRY_OPTIONS.length,
    ...CORP_TYPE_OTHER,
  });

  return CORP_TYPE_BY_COUNTRY_OPTIONS;
}
